import type { CategoryDto } from '../services/categories/categories.service';

export interface CategoryFilterSelection { id: number | null; ids: number[] }
export interface CategoryFilterOption extends CategoryFilterSelection { label: string }

export function categoryFilterOptions(tree: CategoryDto[]): CategoryFilterOption[] {
  const options: CategoryFilterOption[] = [];
  const visit = (node: CategoryDto, path: string[], ancestors: Set<number>): number[] => {
    if (ancestors.has(node.id)) return [];
    const branch = new Set(ancestors).add(node.id);
    const names = [...path, node.name];
    const option: CategoryFilterOption = { id: node.id, label: names.join(' > ') + (node.isActive ? '' : ' (inactive)'), ids: [] };
    options.push(option);
    option.ids = [...new Set([node.id, ...(node.children ?? []).flatMap(child => visit(child, names, branch))])];
    return option.ids;
  };
  tree.forEach(node => visit(node, [], new Set()));
  return options;
}
